var e4 = e4 || {},
    vismaco3 = vismaco3 || {};
(function () {
    'use strict';
    jQuery(function () {
        vismaco3.init();
    });
    vismaco3.init = function () {
        vismaco3.sectionBackgroundColor.init();
        vismaco3.cursor.init();
        vismaco3.modal.init();
        vismaco3.activeCampaign.init();
        vismaco3.lottie.init();
        vismaco3.gsap.init();
        vismaco3.hubspot.init();
    };
    vismaco3.modal = {
        init: function () {
            setTimeout(function () {
                var urlHash = window.location.hash;
                urlHash = urlHash.replace("#", "");
                var modalHash = jQuery( ".js-co3-modal" ).attr("data-modalhash");
                var modalContent = jQuery( "#co3Modal" );

                if (urlHash === modalHash) {
                    modalContent.modal("show");
                }
                else if (modalHash === "") {
                    modalContent.modal("show");
                }
            }, 1000);
        }
    }
    vismaco3.hubspot = {
        init: function () {
            jQuery( document ).ready( function() {
                // Wait for Hubspot script to initialize
                setTimeout(function () {
                    var hubspotForm = jQuery(".hs-form");

                    if (hubspotForm[0]) {
                        console.log("Hubspot form loaded");
                        hubspotForm.on("submit", function() {
                            var hubspotEmailErrorLink = jQuery(".hs_email a");
                            if (hubspotEmailErrorLink[0]) {
                                hubspotEmailErrorLink[0].click();
                            }
                        });
                    }
                }, 2000);
            });
        }
    }
    vismaco3.gsap = {
        init: function () {
            //e4.require.js(e4.settings.require.gsap, e4.settings.require.gsapCSSRule, e4.settings.require.gsapScrollTrigger, function () {

            jQuery( window ).on( 'resize', function() {
                ScrollTrigger.refresh();
            });

            jQuery( document ).ready( function() {
                CSSPlugin.defaultTransformPerspective = 0;
                
                jQuery( '.layered-img-wrapper' ).closest( '.e-section' ).addClass( 'has-stacked-image');
                ScrollTrigger.matchMedia({
                    "(min-width: 992px)": function () {
                        var imageStack1 = gsap
                            .timeline({
                                scrollTrigger: {
                                    trigger: ".layered-img-wrapper",
                                    start: "-=500",
                                    end: "-=300",
                                    scrub: 1,
                                }
                            }).to(".image-layer1", {
                                delay: 0,
                                translateY: 0,
                                ease: Power0.inOut,
                                duration: 2,
                            }).to( ".image-groupe-label", {
                                delay: 2,
                                translateX: 0,
                                opacity: 1,
                                duration: 3,
                                yoyo: true,
                                ease: Power0.inOut,
                            }).to( ".label", {
                                delay: 2,
                                translateX: 0,
                                opacity: 1,
                                yoyo: true,
                                ease: Power0.inOut,
                            });

                        var imageStack2 = gsap
                            .timeline({
                                scrollTrigger: {
                                    trigger: ".layered-img-wrapper",
                                    start: "-=500",
                                    end: "-=300",
                                    scrub: 1,
                                }
                            }).to(".image-layer2", {
                                delay: 0,
                                translateY: "10%",
                                ease: Power0.inOut,
                                duration: 2,
                            });

                        var imageStack3 = gsap
                            .timeline({
                                scrollTrigger: {
                                    trigger: ".layered-img-wrapper",
                                    start: "-=500",
                                    end: "-=300",
                                    scrub: 1,
                                }
                            }).to(".image-layer3", {
                                delay: 0,
                                translateY: "20%",
                                ease: Power0.inOut,
                                duration: 2,
                            });


                        var imageStack4 = gsap
                            .timeline({
                                scrollTrigger: {
                                    trigger: ".layered-img-wrapper",
                                    start: "-=500",
                                    end: "-=300",
                                    scrub: 1,
                                }
                            }).to(".image-layer4", {
                                delay: 0,
                                translateY: "30%",
                                ease: Power0.inOut,
                                duration: 2,
                            });


                        var imageStack5 = gsap
                            .timeline({
                                scrollTrigger: {
                                    trigger: ".layered-img-wrapper",
                                    start: "-=500",
                                    end: "-=300",
                                    scrub: 1,
                                }
                            }).to(".image-layer5", {
                                delay: 0,
                                translateY: "40%",
                                ease: Power0.inOut,
                                duration: 2,
                            });


                        var imageStack6 = gsap
                            .timeline({
                                scrollTrigger: {
                                    trigger: ".layered-img-wrapper",
                                    start: "-=500",
                                    end: "-=300",
                                    scrub: 1,
                                }
                            }).to(".image-layer6", {
                                delay: 0,
                                translateY: "50%",
                                ease: Power0.inOut,
                                duration: 2,
                            });
                    },
                    "(max-width: 991px)": function () {

                        var imageStack1 = gsap
                            .timeline({
                                scrollTrigger: {
                                    trigger: ".layered-img-wrapper",
                                    start: "-=500",
                                    end: "-=300",
                                    scrub: 1,
                                }
                            }).to(".image-layer1", {
                                delay: 0,
                                translateY: 0,
                                ease: Power0.inOut,
                                duration: 2,
                            }).to( ".image-groupe-label", {
                                delay: 2,
                                translateX: 0,
                                opacity: 1,
                                yoyo: true,
                                ease: Power0.inOut,
                            }).to( ".label", {
                                delay: 2,
                                translateX: 0,
                                opacity: 1,
                                yoyo: true,
                                ease: Power0.inOut,
                            });

                        var imageStack2 = gsap
                            .timeline({
                                scrollTrigger: {
                                    trigger: ".layered-img-wrapper",
                                    start: "-=500",
                                    end: "-=300",
                                    scrub: 1,
                                }
                            }).to(".image-layer2", {
                                delay: 0,
                                translateY: "20%",
                                ease: Power0.inOut,
                                duration: 2,
                            });

                        var imageStack3 = gsap
                            .timeline({
                                scrollTrigger: {
                                    trigger: ".layered-img-wrapper",
                                    start: "-=500",
                                    end: "-=300",
                                    scrub: 1,
                                }
                            }).to(".image-layer3", {
                                delay: 0,
                                translateY: "30%",
                                ease: Power0.inOut,
                                duration: 2,
                            });


                        var imageStack4 = gsap
                            .timeline({
                                scrollTrigger: {
                                    trigger: ".layered-img-wrapper",
                                    start: "-=500",
                                    end: "-=300",
                                    scrub: 1,
                                }
                            }).to(".image-layer4", {
                                delay: 0,
                                translateY: "40%",
                                ease: Power0.inOut,
                                duration: 2,
                            });


                        var imageStack5 = gsap
                            .timeline({
                                scrollTrigger: {
                                    trigger: ".layered-img-wrapper",
                                    start: "-=500",
                                    end: "-=300",
                                    scrub: 1,
                                }
                            }).to(".image-layer5", {
                                delay: 0,
                                translateY: "50%",
                                ease: Power0.inOut,
                                duration: 2,
                            });


                        var imageStack6 = gsap
                            .timeline({
                                scrollTrigger: {
                                    trigger: ".layered-img-wrapper",
                                    start: "-=500",
                                    end: "-=300",
                                    scrub: 1,
                                }
                            }).to(".image-layer6", {
                                delay: 0,
                                translateY: "60%",
                                ease: Power0.inOut,
                                duration: 2,
                            });
                    }
                });
            } );                

            var timelineList1 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".main-wrapper",
                        start: "-=700", 
                        end: "+=1500",
                        scrub: 15,
                    }
                }).to(".gsap-list-first", {
                    delay: 0,
                    translateY:-50,
                    ease: Power0.inOut,
                    duration: 15,
                });

            var timelineList2 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".main-wrapper",
                        start: "-=700",
                        end: "+=1500",
                        scrub: 15,
                        //markers: true,
                    }
                }).to(".gsap-list-second", {
                    delay: 0,
                    translateY: 50,
                    ease: Power0.inOut,
                    duration: 15,
                });

            var timelineList3 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".main-wrapper",
                        start: "-=700",
                        end: "+=1500",
                        scrub: 15,
                        //markers: true,
                    }
                }).to(".gsap-list-third", {
                    delay: 0,
                    translateY: -50,
                    ease: Power0.inOut,
                    duration: 15,
                });

            var timelineList4 = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: ".main-wrapper",
                        start: "-=700",
                        end: "+=1500",
                        scrub: 15,
                        //markers: true,
                    }
                }).to(".gsap-list-fourth", {
                    delay: 0,
                    translateY: 50,
                    ease: Power0.inOut,
                    duration: 15,
                });


            ScrollTrigger.matchMedia({
                "(min-width: 992px)": function () {
                    console.log( 'desktop' );
                    var containerTimeline1 = gsap
                        .timeline({
                            scrollTrigger: {
                                trigger: ".gsap-wrapper",
                                start: "-=400",
                                end: "+=800",
                                scrub: 2,
                            }
                        }).to(".gsap-wrapper", {
                            translateY: 0,
                            translateZ: 0,
                            ease: Power0.easeIn,
                            duration: 300,
                        });

                    var containerTimeline2 = gsap
                        .timeline({
                            scrollTrigger: {
                                trigger: ".gsap-wrapper",
                                start: "-=200",
                                end: "+=800",
                                scrub: 2,
                            }
                        }).fromTo(".gsap-wrapper", {
                            xPercent: 40,
                            translateY: "-250px",
                            rotationX: -38,
                            rotationY: 56,
                            rotationZ: 0,
                            skewX: 0,
                            skewY: 0,
                            scaleX: 1.1,
                            scaleY: 1,
                            ease: Power0.easeIn,
                            duration: 300,
                            clearProps: "translateX, translateY, translateZ, rotationX, rotationY, rotationZ",
                        },
                        {
                            xPercent: 0,
                            translateY: "0px",
                            rotationX: 0,
                            rotationY: 0,
                            rotationZ: 0,
                            skewX: 0,
                            skewY: 0,
                            scaleX: 1,
                            scaleY: 1,                            
                            ease: Power0.easeIn,
                            duration: 300,
                            clearProps: "translateX, translateY, translateZ, rotationX, rotationY, rotationZ",
                        });


                    var textContainerTimeline2 = gsap
                        .timeline({
                            scrollTrigger: {
                                trigger: ".gsap-wrapper",
                                start: "-=300",
                                end: "+=575",
                                scrub: 2,
                            }
                        }).to(".gsap-image-container", {
                            translateY: '300px',
                            ease: Power0.easeIn,
                            duration: 300,
                        });
                    
                },
                "(max-width: 991px)": function () {
                    var containerTimeline1 = gsap
                        .timeline({
                            scrollTrigger: {
                                trigger: ".gsap-wrapper",
                                start: "-=400",
                                end: "+=800",
                                scrub: 2,
                            }
                        }).fromTo(".gsap-wrapper", {
                            translateY: 0,
                            translateZ: 0,
                            ease: Power0.easeIn,
                            duration: 0,
                        },
                        {
                            translateY: 0,
                            translateZ: 0,
                            ease: Power0.easeIn,
                            duration: 0,
                        });                   
                    
                    var containerTimeline2 = gsap
                        .timeline({
                            scrollTrigger: {
                                trigger: ".gsap-wrapper",
                                start: "-=200",
                                end: "+=800",
                                scrub: false,
                            }
                        }).fromTo(".gsap-wrapper", {
                            xPercent: 0,
                            translateY: "0px",
                            rotationX: 0,
                            rotationY: 0,
                            rotationZ: 0,
                            skewX: 0,
                            skewY: 0,
                            scaleX: 1,
                            scaleY: 1,
                            ease: Power0.easeIn,
                            duration: 0,
                            clearProps: "translateX, translateY, translateZ, rotationX, rotationY, rotationZ",
                        },
                        {
                            xPercent: 0,
                            translateY: "0px",
                            rotationX: 0,
                            rotationY: 0,
                            rotationZ: 0,
                            skewX: 0,
                            skewY: 0,
                            scaleX: 1,
                            scaleY: 1,
                            ease: Power0.easeIn,
                            duration: 0,
                            clearProps: "translateX, translateY, translateZ, rotationX, rotationY, rotationZ",
                        });
                    
                }                
            });
            
            
            


            //});
        }
    };
    vismaco3.lottie = {
        init: function () {
            jQuery( '.js-vismaco3-lottie-container' ).each( function ( intIndex, domLottieContainer ){
                var jDomNode = jQuery( domLottieContainer ),
                    jLottiePlayer = jDomNode.find( '.js-vismaco3-lottie-player' ),
                    domLottiePlayer = jLottiePlayer[0],
                    strLottiePath = jLottiePlayer.data( 'animationPath' ),
                    lottieAnimation = lottie.loadAnimation({
                    container: domLottiePlayer,
                    renderer: 'svg',
                    loop: false,
                    autoplay: false,
                    path: strLottiePath
                });

                jDomNode.on( 'mouseenter', function () {
                    lottieAnimation.setDirection( 1 );
                    lottieAnimation.play();
                }).on( 'mouseleave', function () {
                    lottieAnimation.setDirection( -1 );
                    lottieAnimation.play();
                });
            }); 
        }
    };
    vismaco3.activeCampaign = {
        init: function () {
            if (jQuery('.js-vismaco3-activecampaign').length > 0) {
                vismaco3.activeCampaign.customCheckbox();
                vismaco3.activeCampaign.requiredStar();
                vismaco3.activeCampaign.styling();
                vismaco3.activeCampaign.errorMsg.init();
            }
        },
        customCheckbox: function () {
            var jActiveCampaignObj = jQuery('.js-vismaco3-activecampaign');
            jActiveCampaignObj.find('._checkbox-radio').addClass('custom-checkbox');
            jActiveCampaignObj.find('._checkbox-radio > input').addClass('custom-control-input').after('<span class="custom-control-indicator"></span>');
        },
        requiredStar: function () {
            var jActiveCampaignObj = jQuery('.js-vismaco3-activecampaign');
            jActiveCampaignObj.find('label').each(function () {
                var jLabelHtml = jQuery(this).html();
                jQuery(this).html(jLabelHtml.replace('*', ' <span class="text-danger">*</span>'));
            });
        },
        styling: function () {
            jQuery('.js-vismaco3-activecampaign style').remove();
            var jFooterForm = jQuery('.e-footer').find('.js-vismaco3-activecampaign');
            jFooterForm.find('label').css({
                'color': '#d9d9d9'
            });
            jQuery('.js-vismaco3-activecampaign').find('._button-wrapper ._submit').removeClass('_submit').addClass('btn btn-primary');
        },
        errorMsg: {
            removeClasses: function () {
                jQuery("._error-inner._no_arrow").hide()
            },
            onSubmit: function () {
                jQuery('._form').on('submit', function () {
                    vismaco3.gdpr.init();
                    if (!jQuery(this).find('input[type=checkbox]').is(':checked')) {
                        vismaco3.activeCampaign.errorMsg.removeClasses();
                    }
                });
            },
            onChange: function () {
                jQuery('._form').on('change', 'input[type=checkbox]', function () {
                    vismaco3.gdpr.init();
                    if (jQuery(this).is(':checked')) {
                        vismaco3.activeCampaign.customCheckbox();
                    } else {
                        vismaco3.activeCampaign.errorMsg.removeClasses();
                    }
                });
            },
            init: function () {
                vismaco3.activeCampaign.errorMsg.onSubmit();
                vismaco3.activeCampaign.errorMsg.onChange();
            }
        }
    };
    vismaco3.cursor = {
        init: function () {
            var intWindowHeight = jQuery(window).height(),
                intWindowWidth = jQuery(window).width();
            if (intWindowWidth > e4.settings.breakpoint.lg) {

                jQuery(document).on('mousemove', function (e) {
                    jQuery('.cursor__follower').attr('style', '--y:' + e.clientY + 'px; --x:' + e.clientX + 'px');
                });

                // Cursor for hover employee
                jQuery('.js-vismaco3-make-cursor-modal').on('mouseenter', function () {
                    jQuery('.cursor__plus').addClass('show').removeClass('hide');
                }).on('mouseleave', function () {
                    jQuery('.cursor__plus').addClass('hide').removeClass('show');
                });

                // Cursor for closing megamenu

                jQuery('.e-header .e-dropdown-mega .nav-link').on('click', function () {

                });

                jQuery('.e-header .e-megamenu-container.dropdown-menu .right-side-of-screen').mouseover(function () {
                    jQuery('.cursor__close').addClass('show').removeClass('hide');
                    jQuery('body').css('cursor', 'none');
                }).mouseleave(function () {
                    jQuery('.cursor__close').addClass('hide').removeClass('show');
                    jQuery('body').css('cursor', 'default');
                });

                jQuery('.e-header .e-megamenu-container.dropdown-menu .right-side-of-screen, .e-header .e-megamenu-container.dropdown-menu .btn-close').on('click', function () {
                    jQuery('.e-megamenu-container.dropdown-menu, .e-dropdown-mega').removeClass('show');
                    jQuery('body').css('cursor', 'default');
                    jQuery('.cursor__close').addClass('hide').removeClass('show');
                });

            }
        }
    };
    
    vismaco3.sectionBackgroundColor = {
        init: function () {
            vismaco3.sectionBackgroundColor.bind();
        },
        bind: function () {
            var arrTargets = jQuery('.js-e-section').toArray(),
                jBody = jQuery('body'),
                jHeader = jQuery('.e-header'),
                jFooter = jQuery('.e-content-footer');

            e4.util.observer.bind(arrTargets, function (domElm) {
                
                if (domElm.isIntersecting === true) {
                    var domElmTarget = domElm.target,
                        jPanel = jQuery(domElmTarget);
                        if (jPanel.data('color') !== undefined) {
                            jBody.removeClass(function (index, css) {
                                return (css.match(/(^|\s)bg-\S+/g) || []).join(' ');
                            });
                            jBody.addClass('bg-' + jPanel.data('color'));
                            
                            jHeader.removeClass(function (index, css) {
                                return (css.match(/(^|\s)before-bg-\S+/g) || []).join(' ');
                            });
                            jHeader.addClass('before-bg-' + jPanel.data('color'));

                            jFooter.removeClass(function (index, css) {
                                return (css.match(/(^|\s)e-theme-\S+/g) || []).join(' ');
                            });
                            jFooter.addClass('e-theme-' + jPanel.data('color'));
                        }
                    
                }
            });
        }
    };

}());
